module.exports = __webpack_public_path__ + "static/media/martin-duggan-profile-pic2020.19f21e5c.jpg";